// Notre Dame's undergraduate majors (#2652). Read on 2026-10-01 from the
// official Academic Catalog's program list (catalog.nd.edu/programs/, the
// 2026-2027 Bulletin of Information): every entry the catalog labels
// "(Major)". Supplementary majors and second majors (taken only alongside a
// first major), minors and graduate programs are left out. The catalog names
// the degree only for Art Studio, Design, Mathematics and Neuroscience; the
// other degrees come from the catalog's own program codes (ba, bs, bfa, bba,
// bar = BArch, bga and the engineering bs codes = Bachelor of Science, as
// the program pages say). Business Analytics carries no code, so its degree
// is left blank. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-notre-dame",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Notre Dame's official 2026-2027 Academic Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, supplementary and second majors (which you add to a first major) and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Architecture",
            "source": {
                "label": "Notre Dame Academic Catalog 2026-2027, Academic Programs",
                "url": "https://catalog.nd.edu/programs/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BArch"
                }
            ]
        },
        {
            "name": "College of Arts and Letters",
            "source": {
                "label": "Notre Dame Academic Catalog 2026-2027, Academic Programs",
                "url": "https://catalog.nd.edu/programs/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Arabic",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art Studio",
                    "degree": "BA"
                },
                {
                    "name": "Art Studio",
                    "degree": "BFA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Design",
                    "degree": "BA"
                },
                {
                    "name": "Design",
                    "degree": "BFA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Film, Television and Theatre",
                    "degree": "BA"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Greek and Roman Civilization",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Economics - Arabic",
                    "degree": "BA"
                },
                {
                    "name": "International Economics - Chinese",
                    "degree": "BA"
                },
                {
                    "name": "International Economics - German",
                    "degree": "BA"
                },
                {
                    "name": "International Economics - Japanese",
                    "degree": "BA"
                },
                {
                    "name": "International Economics - LLR",
                    "degree": "BA"
                },
                {
                    "name": "International Economics - Russian",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics-Honors",
                    "degree": "BA"
                },
                {
                    "name": "Medieval Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience & Behavior",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Program of Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Romance Languages and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Theology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Notre Dame Academic Catalog 2026-2027, Academic Programs",
                "url": "https://catalog.nd.edu/programs/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Keough School of Global Affairs",
            "source": {
                "label": "Notre Dame Academic Catalog 2026-2027, Academic Programs",
                "url": "https://catalog.nd.edu/programs/"
            },
            "majors": [
                {
                    "name": "Global Affairs",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Mendoza College of Business",
            "source": {
                "label": "Notre Dame Academic Catalog 2026-2027, Academic Programs",
                "url": "https://catalog.nd.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Strategic Management",
                    "degree": "BBA"
                }
            ],
            "note": "Applicants who say they intend to major in business learn at admission whether they are pre-approved to do so; without pre-approval, moving into business after the first year is extremely limited.",
            "noteSource": "businessPolicy"
        },
        {
            "name": "College of Science",
            "source": {
                "label": "Notre Dame Academic Catalog 2026-2027, Academic Programs",
                "url": "https://catalog.nd.edu/programs/"
            },
            "majors": [
                {
                    "name": "Applied & Computational Mathematics & Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry/Computing",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience and Behavior",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics in Medicine",
                    "degree": "BS"
                },
                {
                    "name": "Pre-Professional",
                    "degree": "BS"
                },
                {
                    "name": "Science - Computing",
                    "degree": "BS"
                },
                {
                    "name": "Science - Education",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
